class CartNotification extends HTMLElement {
  connectedCallback() {
    document.addEventListener('cart:updated', (e) => this.show(e.detail));
  }

  show(cart) {
    // Lấy đúng item vừa thêm — thường là item cuối cùng trong mảng items
    //const lastItem = cart.items[0];
    //if (!lastItem) return;

    // this.querySelector('.cart-notification__title').textContent = lastItem.product_title;

    this.classList.add('is-visible');

    clearTimeout(this.hideTimeout); // tránh trường hợp add liên tiếp làm timer chồng nhau
    this.hideTimeout = setTimeout(() => {
      this.classList.remove('is-visible');
    }, 3000);
  }
}

customElements.define('cart-notification', CartNotification);